module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/now-with-ai-badge-2.png";